import { VStack, Text } from '@cad-arc';
import { ReactNode } from 'react';
import { SEARCH_FORM_WIDTH } from './constants';

export function FormSection({
    title,
    testId,
    children,
    width,
}: {
    title?: string;
    testId?: string;
    children: ReactNode;
    width?: string | number;
}) {
    return (
        <VStack width={width ?? SEARCH_FORM_WIDTH} align="left" data-testid={testId} gap={1}>
            {title && <Text variant="headingSm">{title}</Text>}
            {children}
        </VStack>
    );
}
